<template>
  <v-menu bottom>
    <template v-slot:activator="{ on }">
      <v-card class="mx-5">
        <v-img
          aspect-ratio="1.77"
          :src="
            image ||
            'https://firebasestorage.googleapis.com/v0/b/beanage-data/o/defaultImage.svg?alt=media&token=fbada6c0-836b-45f2-bbc9-2931f7e1aa12'
          "
          class="white--text align-end"
          height="200px"
          gradient="to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.41)"
          v-on="on"
          style="cursor: pointer"
        >
          <v-card-title
            class="font-weight-bold nowrap-text name"
            v-text="name"
          ></v-card-title>
        </v-img>
      </v-card>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) of items"
        :key="index"
        @click="$emit('menuClick', index)"
      >
        <v-list-item-icon>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: ["image", "items", "name"],
  name: "cards",
};
</script>

<style scoped>
.name {
  background: linear-gradient(to right, #00000079, #00000027, #0000000a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ellipsis {
  position: absolute;
  cursor: pointer;
  top: 20px;
  right: 0;
  color: white;
  font-weight: bold;
  font-size: 25px;
  width: 50px;
  height: 50px;
  text-align: center;
}

.v-card > :first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + :not(.v-btn):not(.v-chip) {
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  -webkit-box-shadow: 3px 6px 15px 1px#494949;
  box-shadow: 3px 6px 15px 1px#494949;
}
</style>